import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form as AntForm } from 'antd';
import styled from 'styled-components';

import asset from 'utils/asset';
import { H2 } from 'components/atoms/Text';

const LoginPageContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    font-family: 'Sofia Pro', sans-serif;
    padding: 0px 20px 0px 20px;
`;

const LoginPageInnerContainer = styled.div`
    padding: 10px;
    text-align: left;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 12px;
    border: 0px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    background-color: white;
`;

const Divider = styled.div`
    height: 1px;
    width: 308px;
    background-color: #9e9e9e;
    border-radius: 1px;
`;

const BottomImage = styled.img`
    position: absolute;
    bottom: 0px;
    width: 25%;
    height: auto;
    display: ${(props) => (props.dimension.width > 725 && props.dimension.height > 470 ? 'block' : 'none')};
`;

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}

const RegisterPassword = ({
    form,
    title,
    onSubmit,
    link,
    linkMsg,
    errorMsg,
    jump,
    learnMoreLink,
    learnMoreLinkMsg,
}) => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const onFormSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err) => {
            if (!err) {
                try {
                    await onSubmit({ name: '', email: '', message: '' });
                    // history.push(jump)
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            }
        });
    };

    return (
        <LoginPageContainer id='loginForm'>
            <div style={{ marginTop: 50, marginBottom: 50 }}>
                <img src={asset.image.ensightfulLogo} alt='Ensightful App Inc.' height={48} />
            </div>
            <LoginPageInnerContainer
                style={{
                    borderRadius: '12px',
                    border: '0px',
                    boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
                }}
            >
                <AntForm
                    style={{
                        width: '95%',
                        maxWidth: '435px',
                        height: '320px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    noValidate
                    onSubmit={onFormSubmit}
                >
                    <div style={{ margin: 'auto' }}>
                        <H2 style={{ padding: 20 }}>
                            <p
                                style={{
                                    fontSize: 24,
                                    fontWeight: '400',
                                    overflowWrap: 'break-word',
                                    textAlign: 'center',
                                }}
                            >
                                {' '}
                                We are sorry that you are having trouble signing in, please contact your instructor for
                                help!
                            </p>
                        </H2>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: 35,
                                marginBottom: 35,
                            }}
                        >
                            <Divider />
                        </div>
                        {link && (
                            <div style={{ textAlign: 'center', marginTop: 20 }}>
                                <Link style={{ marginRight: 10 }} to={link}>
                                    {linkMsg}
                                </Link>
                            </div>
                        )}
                    </div>
                </AntForm>
            </LoginPageInnerContainer>
            <BottomImage
                alt='left_footer_img'
                style={{
                    left: 0,
                }}
                dimension={windowDimensions}
                src={asset.image.loginBackgroundLeft}
                resizemode='contain'
            />
            <BottomImage
                alt='right_footer_img'
                style={{
                    right: 0,
                }}
                dimension={windowDimensions}
                src={asset.image.loginBackgroundRight}
                resizemode='contain'
            />
        </LoginPageContainer>
    );
};

export default AntForm.create({ name: 'RegisterPassword' })(RegisterPassword);
